<template>
  <b-row>
    <b-col>
      <!--  ### DAILY PRICING  ### -->
      <md-card class="island-card">
        <md-card-content>
          <p class="moow-header">Monthly rent</p>

          <md-field>
            <label>
              Monthly Base Price
              <info-toggle :infoContent="i18n_local.info_monthly_base_price" size="small" />
            </label>
            <md-input v-model.number="selPriceMonthly" type="number"></md-input>
            <md-icon>euro_symbol</md-icon>
          </md-field>
          <md-field>
            <label>Security Deposit</label>
            <md-input v-model.number="selDepositMonthly" type="number"></md-input>
            <md-icon>euro_symbol</md-icon>
          </md-field>
          <md-field>
            <label>Discount % for tenancy longer then 3 months</label>
            <md-input
                :value="selMediumPeriodDiscount"
                @input="onSelMediumPeriodDiscountChanged"
                type="number"
                min="0"
                max="100"
                step="1">
            </md-input>
            <span class="md-suffix">%</span>
          </md-field>
          <md-field>
            <label>Discount % for tenancy longer then 6 months</label>
            <md-input
                :value="selLongPeriodDiscount"
                @input="onSelLongPeriodDiscountChanged"
                type="number"
                min="0"
                max="100"
                step="1">
            </md-input>
            <span class="md-suffix">%</span>
          </md-field>
        </md-card-content>
        <md-card-actions>
          <md-button
            @click="showDailyPricing=!showDailyPricing"
            class="md-primary play-cta-button-flat makeup"
          >{{dailyToggleBtnTxt}}</md-button>
        </md-card-actions>
      </md-card>

      <md-card class="island-card" v-if="showDailyPricing">
        <md-card-content>
          <p class="moow-header">Daily rent</p>
          <md-field>
            <label>
              Daily Base Price
              <info-toggle :infoContent="i18n_local.info_monthly_base_price" size="small" />
            </label>
            <md-input v-model.number="selPriceDaily" type="number"></md-input>
            <md-icon>euro_symbol</md-icon>
          </md-field>
          <md-field>
            <label>Security Deposit</label>
            <md-input v-model.number="selDepositDaily" type="number"></md-input>
            <md-icon>euro_symbol</md-icon>
          </md-field>
          <md-field>
            <label>Weekly Discount %</label>
            <md-input v-model.number="selWeeklyDiscount" type="number"></md-input>
            <span class="md-helper-text">Recommended 30% discount for 28+ day stays</span>
            <span class="md-suffix">%</span>
          </md-field>
        </md-card-content>
      </md-card>

      <md-card class="island-card">
        <md-card-header>
          <span class="moow-header">
            Fees
            <info-toggle :infoContent="i18n_local.info_fees" size="small" />
          </span>
        </md-card-header>
        <md-card-content>
          <md-field>
            <label>Cleaning Fee</label>
            <md-input v-model.number="selCleaningFees" type="number"></md-input>
            <md-icon>euro_symbol</md-icon>
          </md-field>
          <md-field>
            <label>Bed Linen & Towel (essentials)</label>
            <md-input v-model.number="selEssentialFees" type="number"></md-input>
            <md-icon>euro_symbol</md-icon>
          </md-field>
        </md-card-content>
      </md-card>

      <md-card class="island-card">
        <md-card-header>
          <span class="moow-header">
            Utility costs
            <info-toggle :infoContent="i18n_local.info_utility_costs" size="small" />
          </span>
        </md-card-header>
        <md-card-content>
          <b-form-group
            id="fieldsetHorizontal"
            breakpoint="lg"
            label
            label-for="inputHorizontal"
            align="left"
          >
            <b-row style="border:none">
              <b-col md="4" v-for="sub in utilityFees" :key="sub.value">
                <b-form-checkbox :value="sub.value" v-model="selUtilityFees">{{sub.text}}</b-form-checkbox>
              </b-col>
            </b-row>
          </b-form-group>
          <b-row v-if="!selUtilityFees || selUtilityFees.length < utilityFees.length" class="mt-3">
            <b-col>
              <span class="moow-info-txt">
                Utilty Cost Cap
                <info-toggle :infoContent="i18n_local.info_ucc" size="small" />
              </span>
              <md-field>
                <label>Max utilty costs included in the rent</label>
                <md-input v-model.number="selUcc" type="number"></md-input>
                <md-icon>euro_symbol</md-icon>
              </md-field>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <span class="moow-info-txt">
                Utilty Billing Cycle
                <info-toggle :infoContent="i18n_local.info_ubc" size="small" />
              </span>
              <md-field>
                <label for="ubc">Select Billing Cycle</label>
                <md-select v-model="selUbc" name="ubc" id="ubc">
                  <md-option value="monthly">Monthly</md-option>
                  <md-option value="quarterly">Quarterly</md-option>
                  <md-option value="annual">Annual</md-option>
                </md-select>
              </md-field>
            </b-col>
          </b-row>
        </md-card-content>
      </md-card>
    </b-col>
  </b-row>
</template>
<script>
const lists = require("@/lists.js");
import InfoToggle from "@/components/interface/buttons/infoToggle.vue";
import { mapGetters } from "vuex";
export default {
  props: [
    "selectedPriceDaily",
    "selectedPriceMonthly",
    "selectedEssentialFees",
    "selectedCleaningFees",
    "selectedDepositDaily",
    "selectedWeeklyDiscount",
    "selectedDepositMonthly",
    "selectedUtilityFees",
    "selectedMediumPeriodDiscount",
    "selectedLongPeriodDiscount",
    "ucc",
    "ubc"
  ],
  data: function() {
    return {
      selPriceDaily: "",
      selPriceMonthly: "",
      selEssentialFees: "",
      selCleaningFees: "",
      selDepositDaily: "",
      selWeeklyDiscount: "",
      selDepositMonthly: "",
      selUtilityFees: [],
      selMediumPeriodDiscount: "",
      selLongPeriodDiscount: "",
      utilityFees: lists.utilityFeesTypeList,
      showDailyPricing: false,
      selUcc: undefined,
      selUbc: undefined
    };
  },
  components: { InfoToggle },

  watch: {
    selectedPriceDaily(newValue, oldValue) {
      this.selPriceDaily = newValue;
      if (newValue) this.showDailyPricing = true;
    },
    selectedPriceMonthly(newValue, oldValue) {
      this.selPriceMonthly = newValue;
    },
    selectedEssentialFees(newValue, oldValue) {
      this.selEssentialFees = newValue;
    },
    selectedCleaningFees(newValue, oldValue) {
      this.selCleaningFees = newValue;
    },
    selectedDepositDaily(newValue, oldValue) {
      this.selDepositDaily = newValue;
    },
    selectedWeeklyDiscount(newValue, oldValue) {
      this.selWeeklyDiscount = newValue;
    },
    selectedDepositMonthly(newValue, oldValue) {
      this.selDepositMonthly = newValue;
    },
    selectedUtilityFees(newValue, oldValue) {
      this.selUtilityFees = newValue;
    },
    selectedMediumPeriodDiscount(newValue, oldValue) {
      this.selMediumPeriodDiscount = newValue;
    },
    selectedLongPeriodDiscount(newValue, oldValue) {
      this.selLongPeriodDiscount = newValue;
    },
    selUtilityFees: {
      deep: true,
      handler: function(val) {
        this.$emit("emitContentChanged");
      }
    },
    selPriceDaily: function(val) {
      this.$emit("emitContentChanged");
    },
    selPriceMonthly: function(val) {
      this.$emit("emitContentChanged");
    },
    selEssentialFees: function(val) {
      this.$emit("emitContentChanged");
    },
    selCleaningFees: function(val) {
      this.$emit("emitContentChanged");
    },
    selDepositDaily: function(val) {
      this.$emit("emitContentChanged");
    },
    selDepositMonthly: function(val) {
      this.$emit("emitContentChanged");
    },
    selMediumPeriodDiscount: function(val) {
      this.$emit("emitContentChanged");
    },
    selLongPeriodDiscount: function(val) {
      this.$emit("emitContentChanged");
    }
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),

    dailyToggleBtnTxt() {
      if (this.showDailyPricing) return "Hide Daily Pricing";
      else return "Show Daily Pricing";
    }
  },
  created() {
    this.populateLocalValuesFromProps();
  },
  methods: {
    populateLocalValuesFromProps() {
      this.selUcc = this.ucc;
      this.selUbc = this.ubc;
      this.selPriceDaily = this.selectedPriceDaily;
      this.selPriceMonthly = this.selectedPriceMonthly;
      this.selEssentialFees = this.selectedEssentialFees;
      this.selCleaningFees = this.selectedCleaningFees;
      this.selDepositDaily = this.selectedDepositDaily;
      this.selWeeklyDiscount = this.selectedWeeklyDiscount;
      this.selDepositMonthly = this.selectedDepositMonthly;
      this.selMediumPeriodDiscount = this.selectedMediumPeriodDiscount;
      this.selLongPeriodDiscount = this.selectedLongPeriodDiscount;
      this.selectedUtilityFees
        ? (this.selUtilityFees = this.selectedUtilityFees)
        : (this.selUtilityFees = []);
    },
    getUbc() {
      return this.selUbc;
    },
    getUcc() {
      return this.selUcc;
    },
    getPriceDaily() {
      return this.selPriceDaily;
    },
    getPriceMonthly() {
      return this.selPriceMonthly;
    },
    getEssentialFees() {
      return this.selEssentialFees;
    },
    getCleaningFees() {
      return this.selCleaningFees;
    },
    getDepositDaily() {
      return this.selDepositDaily;
    },
    getWeeklyDiscount() {
      return this.selWeeklyDiscount;
    },
    getDepositMonthly() {
      return this.selDepositMonthly;
    },
    getUtilityFees() {
      return this.selUtilityFees;
    },
    getMediumPeriodDiscount() {
      return this.selMediumPeriodDiscount;
    },
    getLongPeriodDiscount() {
      return this.selLongPeriodDiscount;
    },
    onSelMediumPeriodDiscountChanged(selMediumPeriodDiscount) {
        this.selMediumPeriodDiscount = this.normalizePercentageValue(selMediumPeriodDiscount);
    },
    onSelLongPeriodDiscountChanged(selLongPeriodDiscount) {
        this.selLongPeriodDiscount = this.normalizePercentageValue(selLongPeriodDiscount);
    },
    normalizePercentageValue(percentageValue) {
        if (percentageValue >= 0 && percentageValue <= 100) {
            return percentageValue;
        }
        if (percentageValue < 0) {
            return 0;
        }

        return 100;
    },
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
.amenities-container {
  max-height: 628px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.amenities-container label {
  margin-bottom: 5px;
  border-radius: 10px;
}
.amenity-section {
  padding: 5px;
}

.amenity-description {
  color: grey;
  font-size: 15px;
  margin-top: 1em;
  font-style: italic;
}

.amenities-form {
  font-size: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/listingComponents/listingPrices.vue